module.exports = __webpack_public_path__ + "img/energy-suppliers.633830b.webp";